<app-ip-modal-mobile [showCloseModal]="false" [showTitle]="false">
  <div class="ip-confirm-action-dialog-title">{{title}}</div>
  <div *ngIf="content" class="ip-confirm-action-dialog-content">{{content}}</div>
  <div class="ip-confirm-action-dialog">
    <div class="ip-confirm-action-dialog__buttons">
      <app-ip-button-modal
          typeBtn="cancel"
          (clicked)="onCancel()"
        >
        {{ "IP.CONFIRM-ACTION-DIALOG.CANCEL" | translate }}
        </app-ip-button-modal>
        <app-ip-button-modal
          [typeBtn]="btnAction ? 'action' : 'submit'"
          (clicked)="onConfirm()"
        >
        {{ "IP.CONFIRM-ACTION-DIALOG.CONFIRM" | translate }}
        </app-ip-button-modal>
      
  </div>
</div>
</app-ip-modal-mobile>